import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-text-input',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FontAwesomeModule, TranslateModule],
  templateUrl: './text-input.component.html',
  styleUrl: './text-input.component.scss'
})
export class TextInputComponent {
  @Input() control: AbstractControl;
  @Input() placeholder: string;
  @Input() type: string = 'text';
  @Input() isTextArea: boolean = false;
  @Input() pattern?: string;
  @Input() numericOnly?: boolean;

  readonly faCheckCircle = faCheckCircle;

  get formControl(): FormControl {
    return this.control as FormControl;
  }

  @ViewChild('inputElement') inputElement!: ElementRef<HTMLInputElement>;

  focus() {
    this.inputElement.nativeElement.focus();
  }

  onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (this.numericOnly) {
      const cleaned = input.value.replace(/\D+/g, '');
      if (input.value !== cleaned) {
        input.value = cleaned;
        this.control?.setValue(cleaned, { emitEvent: false });
      }
    }
  }
}
